import React from "../../__compat__/react/main.entry.mjs.mjs";
import { SkeletonShape } from "../SkeletonShape/SkeletonShape.mjs.mjs";
export const SelectSkeleton = (props) => {
    const height = props.readOnly ? '20px' : '36px';
    const width = props.readOnly ? '200px' : '100%';
    return (React.createElement("div", null,
        React.createElement(SkeletonShape, { variant: "rectangular", width: width, height: height }),
        props.hint && (React.createElement(SkeletonShape, { spaceStackStart: "m", variant: "rectangular", width: "200px", height: "20px" }))));
};
//# sourceMappingURL=Select.skeleton.mjs.mjs.map